export default "__VITE_ASSET__1fb65686__"